// src/features/carousel/screens/CarouselListScreen.js
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import useTitle from '../../../hooks/useTitle'; // सुनिश्चित करें कि यह पाथ सही है

// अपने Carousel API हुक्स को इंपोर्ट करें
import { useGetAllCarouselItemsQuery } from '../services/carouselApi';
// CarouselListItem कंपोनेंट को इंपोर्ट करें
import CarouselListItem from '../components/CarouselListItem';


const CarouselListScreen = () => {
    useTitle('Nirakar Satgur: Carousel List');

    // हम यहां useAuth का उपयोग नहीं कर रहे हैं क्योंकि सभी कैरोसेल आइटम एडमिन के लिए विजिबल होंगे।
    // हालांकि, यदि आप भविष्य में एडमिन रोल के आधार पर विजिबिलिटी नियंत्रित करना चाहते हैं, तो आप इसे जोड़ सकते हैं।

    const {
        data: carouselItems, // डेटा का नाम बदलें
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetAllCarouselItemsQuery('carouselList', { // एक स्थिर आर्गुमेंट दें, या void
        refetchOnFocus: false,
        refetchOnMountOrArgChange: true
    });

    console.log('carouselItems =>', carouselItems);

    let content;

    if (isLoading) {
        content = <Spinner color={"#FFF"} />; // सुनिश्चित करें कि यह Spinner कंपोनेंट सही तरह से रेंडर हो रहा है (Bootstrap Spinner)
    }

    if (isError) {
        content = <p className="errmsg">{error?.data?.message || 'Failed to load carousel items.'}</p>;
    }

    if (isSuccess) {
        // चूंकि हमारे पास RTK Query में एंटिटी एडाप्टर नहीं है, हम सीधे एरे का उपयोग करेंगे
        // यदि आपका API `ids` और `entities` वापस करता है, तो आप उसी तरह से उपयोग कर सकते हैं।
        // फिलहाल, हम मान रहे हैं कि `carouselItems` एक एरे है।
        // यदि आपका API { data: [...] } स्ट्रक्चर में देता है, तो carouselItems.data का उपयोग करें।

        const { data: items = [] } = carouselItems; // सुनिश्चित करें कि आपका API `data` प्रॉपर्टी में एरे देता है

        const tableContent = items?.length
            ? items.map((item, index) => <CarouselListItem key={item._id} carouselItemId={item._id} index={index} />)
            : null;

        content = (
            <>
                <div className="flex justify-between">
                    <h2 className="pageHeading">Carousel List</h2>
                    <Link className="btn btn-primary mb-20" to='/dashboard/carousel/new'>Add New Carousel Item</Link>
                </div>
                <table className="table table--notes">
                    <thead className="table__thead">
                        <tr>
                            <th scope="col" className="table__th">S.No.</th>
                            <th scope="col" className="table__th">Title</th>
                            <th scope="col" className="table__th">Type</th>
                            <th scope="col" className="table__th">Visible</th>
                            <th scope="col" className="table__th">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableContent}
                    </tbody>
                </table>
            </>
        );
    }

    return content;
};

export default CarouselListScreen;